import { jsxs, jsx } from "react/jsx-runtime";
import { MarkdownRenderer } from "@nxt-costco-com/forge-components";
import { generateStyles } from "../utils.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import GenericImageHandler from "../../../Util/GenericImageHandler.js";
import { FeatureBadge } from "./FeatureBadge.js";
import { FeatureRating } from "./FeatureRating.js";
import { RowContainer } from "./styles.js";
function FeatureRow({
  row,
  primaryColor,
  secondaryColor,
  backgroundColor
}) {
  var _a, _b;
  if (!row) {
    return null;
  }
  const iconImage = (_a = row.icon_image) == null ? void 0 : _a[0];
  return /* @__PURE__ */ jsxs(RowContainer, { children: [
    (iconImage == null ? void 0 : iconImage.url) && /* @__PURE__ */ jsx(
      GenericImageHandler,
      {
        sx: {
          marginRight: "8px",
          width: "30px"
        },
        alt: "",
        src: iconImage == null ? void 0 : iconImage.url
      }
    ),
    /* @__PURE__ */ jsxs(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flexDirection: "column"
        },
        children: [
          /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                color: (primaryColor == null ? void 0 : primaryColor.hex) || "#333",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px"
              },
              children: /* @__PURE__ */ jsx(MarkdownRenderer, { markdown: row.feature_title })
            }
          ),
          /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                color: (secondaryColor == null ? void 0 : secondaryColor.hex) || "#5f5f5f",
                fontSize: "12px",
                lineHeight: "16px"
              },
              children: /* @__PURE__ */ jsx(MarkdownRenderer, { markdown: row.feature_subtitle })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: { alignSelf: row.feature_subtitle ? "start" : "center" },
        children: /* @__PURE__ */ jsx(
          FeatureBadge,
          {
            backgroundColor: generateStyles(backgroundColor),
            color: (_b = backgroundColor == null ? void 0 : backgroundColor.text_color) == null ? void 0 : _b.hex,
            text: row.feature_tag_text
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: { alignSelf: row.feature_subtitle ? "start" : "center" },
        children: /* @__PURE__ */ jsx(
          FeatureRating,
          {
            id: row._metadata.uid,
            rating: row.feature_rating
          }
        )
      }
    )
  ] });
}
export {
  FeatureRow
};
